import { render, staticRenderFns } from "./ArtistBooking.vue?vue&type=template&id=94404996&scoped=true"
import script from "./ArtistBooking.vue?vue&type=script&lang=js"
export * from "./ArtistBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94404996",
  null
  
)

export default component.exports